import React, { useRef, useState } from 'react';
import { Alert, Button, Drawer, Empty } from 'antd';
import { HistoryOutlined, SaveOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { createRecommendationRun } from '@/apis/posts';
import usePrivateAction from '@/utils/usePrivateAction';
import { logicalRequest } from '@/utils/logicalRequest';
import RecommendationBatch from '@/components/recommendationbatch';
import './SavedRecommendations.scss';

const SavedRecommendations = ({ filters, isMobile }) => {
  const [open, setOpen] = useState(false); const [batch, setBatch] = useState(null);
  const { busy, run } = usePrivateAction(); const requestRef = useRef(null);
  return <div className="savedRecommendations-tools"><Button className="savedRecommendations-create" icon={<SaveOutlined aria-hidden="true" />} title="生成并保存推荐" disabled={busy} loading={busy} onClick={() => run(() => createRecommendationRun(logicalRequest(requestRef, { ...filters, limit: 10 })), result => {
    requestRef.current = null; setBatch(result); setOpen(true);
  }, '推荐生成失败，请重试')}><span className="savedRecommendations-label">生成并保存推荐</span></Button><Link className="savedRecommendations-history" to="/personal/recommendation-history" title="查看推荐记录"><HistoryOutlined aria-hidden="true" /><span className="savedRecommendations-label">查看推荐记录</span></Link>
    {isMobile && <span className="savedRecommendations-hint">生成后自动保存，方便稍后回看。</span>}
    <Drawer title="已保存的推荐" open={open} onClose={() => setOpen(false)} size={isMobile ? '100%' : 560} destroyOnHidden>
      <Alert type="info" showIcon title="保存本次推荐，方便回看。推荐不代表报名成功，加入活动仍需申请。" />
      {batch && (batch.items.length ? <RecommendationBatch batch={batch} /> : <Empty description="暂无符合条件的推荐" />)}
    </Drawer>
  </div>;
};
export default SavedRecommendations;
